<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Roles</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Rol</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="roles"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
              <div slot="empty" v-if="roles">
                Sin datos disponibles
              </div>
              <el-table-column label="Rol" prop="name" />
              <el-table-column label="Cantidad de permisos" prop="permissions_count" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editRole(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="deleteRole(row)">
                    <span class="btn-inner--text">Eliminar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear rol</h6>
        <form class="new-event--form" @submit.prevent="addRole">
          <base-input label="Nombre"
                      placeholder="Nombre del rol"
                      v-model="role.name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.name" />
          <base-input label="Seleccione permisos">
            <multiselect v-model="role.permissions" :options="permissions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione permisos" label="name" track-by="key" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.permissions" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addRole">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar rol</h6>
        <form class="new-event--form" @submit.prevent="editRole">
          <base-input label="Nombre"
                      placeholder="Nombre dl rol"
                      v-model="role.name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.name" />
          <base-input label="Seleccione permisos">
            <multiselect v-model="role.permissions" :options="permissions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione permisos" label="name" track-by="key" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.permissions" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateRole">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect'
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        roles: [],
        permissions: [
          { name: 'Gestionar Opciones', key: 'opciones' },
          { name: 'Gestionar Autorizaciones', key: 'autorizaciones evento' },
          { name: 'Gestionar Ciudades', key: 'ciudades' },
          { name: 'Gestionar Terminales', key: 'terminales' },
          { name: 'Gestionar Dispositivos', key: 'dispositivos' },
          { name: 'Gestionar Agencias', key: 'agencias' },
          { name: 'Gestionar Roles', key: 'roles' },
          { name: 'Gestionar Usuarios', key: 'users' },
          { name: 'Gestionar Layouts', key: 'layouts' },
          { name: 'Gestionar Unidades', key: 'unidades' },
          { name: 'Gestionar Operadores', key: 'operadores' },
          { name: 'Gestionar Venta', key: 'venta' },
          { name: 'Gestionar Boletos', key: 'boletos' },
          { name: 'Gestionar Facturación', key: 'facturacion' },
          { name: 'Gestionar Facturación Global', key: 'facturacionglobal' },
          { name: 'Gestionar Abordaje de Pasajeros', key: 'abordaje' },
          { name: 'Gestionar Abordaje de Equipaje', key: 'abordaje equipaje' },
          { name: 'Gestionar Documentar', key: 'documentar' },
          { name: 'Gestionar Tramos', key: 'tramos' },
          { name: 'Gestionar Rutas', key: 'rutas' },
          { name: 'Gestionar Corridas', key: 'corridas' },
          { name: 'Gestionar Canje Masivo', key: 'canje masivo' },
          { name: 'Gestionar Descuentos', key: 'descuentos' },
          { name: 'Gestionar Precios', key: 'precios' },
          { name: 'Gestionar Movimientos de caja', key: 'movimientos caja' },
          { name: 'Gestionar Arqueos', key: 'arqueos' },
          { name: 'Gestionar Arqueos cualquier Agencia', key: 'arqueos cualquier agencia' },
          { name: 'Realizar Reserva', key: 'autorizar realizar reserva' },
          { name: 'Anular Reserva', key: 'autorizar anular reserva' },
          { name: 'Autorizar Bloqueo Asientos', key: 'autorizar bloqueo asiento' },
          { name: 'Autorizar Descuento', key: 'autorizar descuento' },
          { name: 'Autorizar Canje sin Pago', key: 'autorizar canje sin pago' },
          { name: 'Autorizar Canje con Devolución', key: 'autorizar canje con devolucion' },
          { name: 'Autorizar Canje despues de Salida', key: 'autorizar canje despues salida' },
          { name: 'Autorizar Anular Boleto', key: 'autorizar anular boleto' },
          { name: 'Autorizar Reimpresión Boleto', key: 'reimpresion boleto' },
          { name: 'Gestionar Reporte Boletos', key: 'reporte boletos' },
          { name: 'Gestionar Reporte Salidas y Servicios', key: 'reporte salidas' },
        ],
        selectedRows: [],
        query: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 roles por página'},
          {value:'10', descripcion: '10 roles por página'},
          {value:'25', descripcion: '25 roles por página'},
          {value:'50', descripcion: '50 roles por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        role: {
          type: "roles",
          name: null,
          permissions: [],
        }
      };
    },

    mounted() {
        //
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { name: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("roles/list", params).then(() => {
          this.roles = this.$store.getters["roles/list"];
          this.total = this.$store.getters["roles/listTotal"];
        });
        this.loading = false;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.role.name = null;
        this.role.permissions = null;
      },

      async addRole(){
        try {
        await this.$store.dispatch("roles/add", this.role);

        this.$notify({
          type: "success",
          message: "Rol creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editRole(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.role.name = row.name;
        const permissions = [];
        //asignacion de permisos por nombre especial
        row.permissions.forEach(item => {
          const permission = item.name.split(' ');
          permission.shift();
          if(permission.length === 1){
            if(permissions.includes(permission[0]) == false){
              permissions.push(permission[0]);
            }
          }
          if(permission.length === 2){
            if(permissions.includes(permission[0]+' '+permission[1]) == false){
              permissions.push(permission[0]+' '+permission[1]);
            }
          }
          if(permission.length === 3){
            if(permissions.includes(permission[0]+' '+permission[1]+' '+permission[2]) == false){
              permissions.push(permission[0]+' '+permission[1]+' '+permission[2]);
            }
          }
          if(permission.length === 4){
            if(permissions.includes(permission[0]+' '+permission[1]+' '+permission[2]+' '+permission[3]) == false){
              permissions.push(permission[0]+' '+permission[1]+' '+permission[2]+' '+permission[3]);
            }
          }
        });
        this.role.permissions = this.permissions.filter(item => permissions.includes(item.key));
        this.role.id = row.id;
      },

      async updateRole() {
        try{
          await this.$store.dispatch("roles/update", this.role);
          this.$notify({
            type: "success",
            message: "Rol actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      async deleteRole(row) {
        const confirmation = await swal.fire({
          title: `¿Desea eliminar este rol?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
            if(row.validation_delete > 0){
              this.$notify({
              type: "danger",
              message: "Este rol esta asociado al menos a un usuario.",
              duration: -1
              });
            }else{
              await this.$store.dispatch("roles/destroy", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Rol eliminado satisfactoriamente.",
              duration: -1
            });
            }
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style>
    
  </style>